import { useCallback } from "react"
import type { ChangeEvent } from "react"
import { FormControlLabel, Switch } from "@mui/material"
import type { FormControlLabelProps, SxProps, Theme } from "@mui/material"
import { isScheduledWorkflowNotFound } from "resources/scheduled-workflows/errors"
import { useScheduledWorkflowEmailSubscription, useSetScheduledWorkflowEmailSubscription } from "resources/scheduled-workflows/hooks"

const REPORT_EMAIL_SUBSCRIPTION_LABEL = "Email me new reports from this workflow"

const LABEL_SX = { m: 0, pb: 1.5, gap: 1, alignSelf: "flex-start", color: "text.secondary" } satisfies SxProps<Theme>
const LABEL_SLOT_PROPS = { typography: { variant: "body2" } } satisfies FormControlLabelProps["slotProps"]

interface ReportEmailSubscriptionProps {
  scheduledWorkflowId: string
}

export function ReportEmailSubscription({ scheduledWorkflowId }: ReportEmailSubscriptionProps) {
  const { data, error } = useScheduledWorkflowEmailSubscription(scheduledWorkflowId)
  const { mutate, isPending } = useSetScheduledWorkflowEmailSubscription(scheduledWorkflowId)
  const toggle = useCallback((_event: ChangeEvent<HTMLInputElement>, checked: boolean) => mutate(checked), [mutate])
  if (data == null || isScheduledWorkflowNotFound(error)) return null
  return (
    <FormControlLabel
      sx={LABEL_SX}
      label={REPORT_EMAIL_SUBSCRIPTION_LABEL}
      slotProps={LABEL_SLOT_PROPS}
      control={<Switch size="small" checked={data.subscribed} disabled={isPending} onChange={toggle} />}
    />
  )
}
